export class GraphqlQueryObject {
  defaultFields: string[] = ['id', 'nameTh', 'nameEn', 'code'];
  name: string;
  fields: string[];
  sort?: GraphqlQuerySortOptions;
  type?: any;
  active?: boolean;
  locationType?: any;
  allowManualAdjustment?: boolean;
}

export interface GraphqlQuerySortOptions {
  orderBy?: OrderByEnum;
  orderDirection?: OrderDirectionEnum;
}

export enum OrderByEnum {
  CODE = 'CODE',
  CODE2 = 'code',
  NAME_EN = 'NAME_EN',
  NAME_TH = 'NAME_TH',
  BRAND_NAME_EN = 'BRAND_NAME_EN',
  BRAND_NAME_TH = 'BRAND_NAME_TH',
  NAME = 'name',
  ID = 'ID',
  WMS_CODE = 'WMS_CODE'
}

export enum OrderDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export class NewMasterData {
  id: string;
  code: string;
  nameTh: string;
  nameEn: string;
}
